module.exports = __webpack_public_path__ + "resources/img/img_datahunt2_m.b1ff8b7c029cde4b861db40c1581744c.png";